// 게임 시스템들의 초기화를 담당하는 클래스
class SystemsInitializer {
  constructor(game) {
    this.game = game;
  }

  // 게임 시스템 컴포넌트 초기화
  async initialize() {
    Utils.log("게임 시스템 초기화 중...");

    // 기본 시스템들 초기화
    // webpack 빌드에서는 window를 통해 접근, 개별 스크립트 로드 시에는 직접 접근
    const InputHandlerClass =
      typeof InputHandler !== "undefined" ? InputHandler : window.InputHandler;
    const CameraControllerClass =
      typeof CameraController !== "undefined"
        ? CameraController
        : window.CameraController;
    const SceneManagerClass =
      typeof SceneManager !== "undefined" ? SceneManager : window.SceneManager;
    const UIManagerClass =
      typeof UIManager !== "undefined" ? UIManager : window.UIManager;

    this.game.inputHandler = new InputHandlerClass();
    this.game.cameraController = new CameraControllerClass(this.game.camera);
    this.game.sceneManager = new SceneManagerClass(this.game.scene, this.game);
    this.game.uiManager = new UIManagerClass();

    // 업그레이드 매니저 초기화 (플레이어 초기화 이후에 생성되므로 connectSystems에서 처리)

    Utils.log("게임 시스템 초기화 완료");
  }

  // 시스템들 연결
  connectSystems() {
    Utils.log("시스템 연결 중...");

    // 업그레이드 매니저 초기화 (플레이어가 필요하므로 여기서 생성)
    // webpack 빌드에서는 window를 통해 접근, 개별 스크립트 로드 시에는 직접 접근
    const UpgradeManagerClass =
      typeof UpgradeManager !== "undefined"
        ? UpgradeManager
        : window.UpgradeManager;
    this.game.upgradeManager = new UpgradeManagerClass(this.game);

    // 플레이어에게 적들 참조 제공 (새로운 적 시스템만)
    if (this.game.enemySpawnManager) {
      this.game.player.setEnemies(this.game.enemySpawnManager.enemies);
    }

    // 카메라를 플레이어에 연결
    this.game.cameraController.setTarget(this.game.player);

    // 적 스폰 시스템과 플레이어 연결
    if (this.game.enemySpawnManager) {
      this.game.enemySpawnManager.setPlayer(this.game.player);
    }

    // 적 스폰 매니저와 스폰 스케줄러 연결
    if (this.game.enemySpawnManager && this.game.spawnScheduler) {
      this.game.enemySpawnManager.setSpawnScheduler(this.game.spawnScheduler);
    }

    Utils.log("시스템 연결 완료");
  }
}

// webpack 빌드를 위해 default export 추가
export default SystemsInitializer;
